import React from 'react';
import './Section3.css'

const Section3 = () => {

  return (
<section className="sec3 section">
  <div className="sec3-container container">
    <div className="row">
      <div className="col-md-4">
      <div className="section-title"><span>ACTIVIDADES</span></div>
        <p className="color-2">
        Vive una experiencia única en Casa origen, donde la aventura y el descanso se fusionan en perfecta armonía.
        </p>
        <p className="color-2">
        Explora todas las actividades que este alojamiento tiene para ti y transforma tu manera de desconectarte.
        </p>
        <div className="sc1-reserv">
          <div className="reserv-icon">
            <i className="ri-phone-line"></i>
          </div>
          <div className="reserv-info">
            <span>Reserva Telefónica</span>
            <p><a href="tel:+573188959559" className="text-decoration-none">+57 318 895 9559</a></p>
          </div>
        </div>
      </div>

      <div className="col-md-8">
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">

            {/* Agrupamos las tarjetas en grupos de 2 */}
            {[
              [
                { title: "Ecohotel", img: "/ecohotel.JPG" },
                { title: "Prácticas", img: "/practicas.JPG" }
              ],
              [
                { title: "Granja", img: "/sec3_granja.jpg" },
                { title: "Senderismo", img: "/camping.jpeg" }
              ],
              [
                { title: "Restaurante", img: "/sec3_restaurante.JPG" },
                { title: "Spa", img: "/sec3_spa.jpeg" }
              ],
              [
                { title: "Pesca", img: "/sec3_pesca.jpg" },
                { title: "Camping", img: "/camping.jpeg" }
              ]
            ].map((group, index) => (
              <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                <div className="row">
                  {group.map((item, subIndex) => (
                    <div key={subIndex} className="col-md-6">
                      <div className="card h-100 shadow-sm">
                        <div className="card-img-container" style={{ height: "200px", overflow: "hidden" }}>
                          <img 
                            src={item.img} 
                            className="card-img-top" 
                            alt={item.title} 
                            style={{ width: "100%", height: "200px", objectFit: "cover" }}
                          />
                        </div>
                        <div className="card-body text-center">
                          <h5 className="card-title">{item.title}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

          </div>

          {/* Carousel Controls */}
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>

          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>

        </div>
      </div>

    </div>
  </div>
</section>
  )
}

export default Section3
